import { Grid } from '@mui/material';
import React from 'react';
import { APP_ROUTES } from '../../../common/constants/Routes';
import { useForm } from 'react-hook-form';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../common/Header';

import { useTranslation } from 'react-i18next';
import DipFrom from './DipFrom';

function ViewDipReading() {
  const location = useLocation();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    reset,
  } = useForm({
    defaultValues: {
      entry_date: location.state.data?.data?.entry_date || '',
      ullage: location.state.data?.data?.ullage || '',
      tank_stock: location.state.data?.data?.tank_stock || '',
      tank_id: location.state.data?.data?.tank_id || '',
      user_id: location.state.data?.data?.user_id || '',
      dip_reading: location.state.data?.data?.dip_reading || '',
    },
  });
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    console.log(data);
    navigate(APP_ROUTES.DIP);
  };
  const { t } = useTranslation();
  return (
    <Grid container mb={5}>
      <Grid xs={12} p={2}>
        <Header
          view={true}
          header={t('VIEW_DIP_READING')}
          route={APP_ROUTES.DIP}
          buttonName={t('GO_BACK')}
          buttonIcon={SubdirectoryArrowRightIcon}
        />
      </Grid>
      <Grid xs={12}>
        <DipFrom
          reset={reset}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          control={control}
          register={register}
          errors={errors}
          watch={watch}
        />
      </Grid>
    </Grid>
  );
}

export default ViewDipReading;
